import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle `
*{
    box-sizing : border-box ;
    margin : 0;
    }
    body{
    background-color: #564a3c;
    }
`;